import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import numberGrow from '@blade/common/components/number/index.vue';
import { searchCenterStore } from '@blade-sxp/search-center/store/searchCenter';
import colors from '@/styles/color.scss';
let Test = class Test extends Vue {
    showIndex = '';
    index = 0;
    mapPointArr = [];
    zoneId = '';
    deviceId = '';
    colors = colors;
    get selectNumber() {
        return searchCenterStore.selectNumber;
    }
    get chooseIndex() {
        return searchCenterStore.choseIndex;
    }
    get isMap() {
        return searchCenterStore.isMap;
    }
    handleClick(item) {
        searchCenterStore.updateIsdevicedClick(false);
        searchCenterStore.updateSelectNumber(Number(item));
        let chooseIndex = this.mapPointArr.findIndex((ele) => ele.showIndex === this.showIndex);
        if (this.chooseIndex === chooseIndex) {
            searchCenterStore.updateClickZoneId(this.zoneId);
            searchCenterStore.updateMap(!this.isMap);
        }
        else {
            // 点击进行线动画 并联动左侧列表高亮 记录设备id 高亮左侧列表
            searchCenterStore.updateClickZoneId(this.zoneId);
            searchCenterStore.updateChoseIndex(chooseIndex);
        }
    }
    onMouseEnter() {
        this.$emit('onMouseEnter');
    }
    onMouseLeave() {
        this.$emit('onMouseLeave');
    }
};
Test = __decorate([
    Component({
        name: 'card',
        components: {
            numberGrow,
        },
        i18n: {},
    })
], Test);
export default Test;
